import { useRef } from 'react'

export function useAiAskBarRefs(attachments) {
  const fileInputRef = useRef(null)
  const composerEditorRef = useRef(null)
  const dictationCancelRef = useRef(null)
  const connectContextRef = useRef(null)
  const connectionsButtonRef = useRef(null)
  const attachmentsRef = useRef(attachments)

  return {
    fileInputRef,
    composerEditorRef,
    dictationCancelRef,
    connectContextRef,
    connectionsButtonRef,
    attachmentsRef,
  }
}
